<div class="wrapper">
  <div class="content">
    <mat-card>
      <mat-card-header>
        <mat-card-header></mat-card-header>
        <mat-icon svgIcon="close"
                class="close-x"
                (click)="removeComponent()"></mat-icon>
      </mat-card-header>
      <div *ngIf="!content">
        <mat-spinner color="accent"></mat-spinner>
      </div>
      <mat-card-content *ngIf="content">
        <div class="additional-info-items-layer-content"
                 [innerHTML]="content | safeHtml">
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button
                size="small"
                color="primary"
                (click)="removeComponent()"
                translate
        >
          i18n.button.close
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/collage-designer/additional-info-item-components/external-html-content.component.html